"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stem;
/**
 * MIT License
 *
 * Copyright (c) 2016 Alexander Kiryukhin
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * https://github.com/neonxp/Stemmer/blob/master/src/NXP/Stemmer.php
 */

/**
 * Checks if the input character is a Russian vowel.
 *
 * @param {string} char             The character to be checked.
 * @param {Object} morphologyData   The Russian morphology data.
 *
 * @returns {boolean} Whether the input character is a Russian vowel.
 */

var isVowel = function isVowel(char, morphologyData) {
  return morphologyData.externalStemmer.vowels.includes(char);
};
/**
 * Determines the RV region of the word.
 *
 * @param {string} word             The word checked.
 * @param {Object} morphologyData   The Russian morphology data.

 *
 * @returns {int} The RV region index.
 */


var findRvRegion = function findRvRegion(word, morphologyData) {
  var rv = 0;
  var state = 0;
  var wordLength = word.length;

  for (var i = 1; i < wordLength; i++) {
    var prevChar = word.substring(i - 1, i);
    var char = word.substring(i, i + 1);

    switch (state) {
      case 0:
        if (isVowel(char, morphologyData)) {
          rv = i + 1;
          state = 1;
        }

        break;

      case 1:
        if (isVowel(prevChar, morphologyData) && isVowel(char, morphologyData)) {
          state = 2;
        }

        break;

      case 2:
        if (isVowel(prevChar, morphologyData) && isVowel(char, morphologyData)) {
          return rv;
        }

        break;
    }
  }

  return rv;
};
/**
 * Removes the endings from the word.
 *
 * @param {string}          word	The word to check.
 * @param {string|string[]} regex	The regex or a pair of regexes to match.
 * @param {int}             region	The word region
 *
 * @returns {string|null}	The word if the stemming rule could be applied or null otherwise.
 */


var removeEndings = function removeEndings(word, regex, region) {
  var prefix = word.substr(0, region);
  var ending = word.substr(prefix.length);
  var currentRegex;

  if (Array.isArray(regex)) {
    currentRegex = new RegExp(regex[0], "i");

    if (currentRegex.test(ending)) {
      word = prefix + ending.replace(currentRegex, "");
      return word;
    }

    currentRegex = new RegExp(regex[1], "i");
  } else {
    currentRegex = new RegExp(regex, "i");
  }

  if (currentRegex.test(ending)) {
    word = prefix + ending.replace(currentRegex, "");
    return word;
  }

  return null;
};
/**
 * Removes inflectional suffixes from the word.
 *
 * @param {string} word             The word to check.
 * @param {Object} morphologyData   The Russian morphology data.
 * @param {int}    rv               The word rv region.
 *
 * @returns {string}	The word after inflectional suffixes were removed.
 */


var removeInflectionalSuffixes = function removeInflectionalSuffixes(word, morphologyData, rv) {
  var removeDerivationalNounSuffix = removeEndings(word, morphologyData.externalStemmer.regexDerivationalNounSuffix, rv);

  if (removeDerivationalNounSuffix) {
    return removeDerivationalNounSuffix;
  } // Try to find a PERFECTIVE GERUND ending. If it exists, remove it and finalize the step.


  var removeGerundSuffixes = removeEndings(word, [morphologyData.externalStemmer.regexPerfectiveGerunds1, morphologyData.externalStemmer.regexPerfectiveGerunds2], rv);

  if (removeGerundSuffixes) {
    word = removeGerundSuffixes;
  } else {
    // If there is no PERFECTIVE GERUND ending then try removing a REFLEXIVE ending.
    var removeReflexiveSuffixes = removeEndings(word, morphologyData.externalStemmer.regexReflexives, rv);

    if (removeReflexiveSuffixes) {
      word = removeReflexiveSuffixes;
    } // Try to remove following endings (in this order): ADJECTIVAL, VERB, NOUN. If one of them is found the step is finalized.


    var regexAdjective = morphologyData.externalStemmer.regexAdjective;
    var removeParticipleSuffixes = removeEndings(word, morphologyData.externalStemmer.regexParticiple + regexAdjective, rv);
    var removeAdjectiveSuffixes = removeEndings(word, regexAdjective, rv);

    if (removeParticipleSuffixes) {
      word = removeParticipleSuffixes;
    } else if (removeAdjectiveSuffixes) {
      word = removeAdjectiveSuffixes;
    } else {
      var removeVerbalSuffixes = removeEndings(word, [morphologyData.externalStemmer.regexVerb1, morphologyData.externalStemmer.regexVerb2], rv);

      if (removeVerbalSuffixes) {
        word = removeVerbalSuffixes;
      } else {
        var removeNounSuffixes = removeEndings(word, morphologyData.externalStemmer.regexNoun, rv);

        if (removeNounSuffixes) {
          word = removeNounSuffixes;
        }
      }
    }
  }

  return word;
};
/**
 * Checks whether a word is in the full-form exception list and if so returns the canonical stem.
 *
 * @param {string} word	      The word to be checked.
 * @param {Object} exceptions The list of full-form exceptions to be checked in.
 *
 * @returns {null|string} The canonical stem or null if nothing was found.
 */


var checkWordInFullFormExceptions = function checkWordInFullFormExceptions(word, exceptions) {
  var _iterator = _createForOfIteratorHelper(exceptions),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var paradigm = _step.value;

      if (paradigm[1].includes(word)) {
        return paradigm[0];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
};
/**
 * Returns a canonical stem for verbs with multiple stems.
 *
 * @param {string}  word                    The word to canonicalize.
 * @param {Array}   wordsWithMultipleStems  An array of arrays of stems belonging to one word.
 *
 * @returns {string} A canonical stem or the original word.
 */


var canonicalizeStems = function canonicalizeStems(word, wordsWithMultipleStems) {
  var multipleStems = wordsWithMultipleStems.find(function (stems) {
    return stems.includes(word);
  });

  if (multipleStems) {
    return multipleStems[0];
  }

  return word;
};
/**
 * Stems russian words.
 *
 * @param {string} word             The word to stem.
 * @param {Object} morphologyData   The Russian morphology data.
 *
 * @returns {string}	The stemmed word.
 */


function stem(word, morphologyData) {
  // Check if word is in the doNotStemSuffix exception list.
  if (morphologyData.doNotStemSuffix.includes(word)) {
    return word;
  } // Check if the word is on the list of exceptions for which we listed all forms and the stem.


  var fullFormException = checkWordInFullFormExceptions(word, morphologyData.exceptionStemsWithFullForms);

  if (fullFormException) {
    return fullFormException;
  }

  var rv = findRvRegion(word, morphologyData); // Step 1: Remove inflectional suffixes if they are present in the word.

  word = removeInflectionalSuffixes(word, morphologyData, rv); // Step 2: If the word ends in "и", remove it.

  var removeIEnding = removeEndings(word, morphologyData.externalStemmer.regexI, rv);

  if (removeIEnding) {
    word = removeIEnding;
  } // Step 3: There can be one of three options:
  // 1. If the word ends in нн, remove the last letter.


  if (word.endsWith(morphologyData.externalStemmer.doubleN)) {
    word = word.substr(0, word.length - 1);
  } // 2. If the word ends in a SUPERLATIVE ending, remove it and then again the last letter if the word ends in "нн".


  var removeSuperlativeSuffixes = removeEndings(word, morphologyData.externalStemmer.regexSuperlative, rv);

  if (removeSuperlativeSuffixes) {
    word = removeSuperlativeSuffixes;
  } // 3. If the word ends in "ь", remove it.


  var removeSoftSignEnding = removeEndings(word, morphologyData.externalStemmer.regexSoftSign, rv);

  if (removeSoftSignEnding) {
    word = removeSoftSignEnding;
  } // Check if the stem is on the list of stems that belong to one word and if so, return the canonical stem.


  var canonicalizedStem = canonicalizeStems(word, morphologyData.stemsThatBelongToOneWord);

  if (canonicalizedStem) {
    return canonicalizedStem;
  }

  return word;
}